import React from 'react';

import Paras from '../../paras';

import healingKey from './img/icon-pt1-healing-6-key.png';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';

import * as css from './index.module.css';
import SkillBar from './skill-bar';

const prefix = 'part1.c';

export default function Combat() {
    const damageAnchor = i18n(`${prefix}.ad.anchor`, { md : false });

    return <>
        <SectionHeader name="combat" />

        <div className={css.cols}>
            <div className={css.col1}>
                <Paras path={`${prefix}.para`} end={1}/>
            </div>
            <div className={css.col2}>
                <p>{i18n(`${prefix}.para.2`)}</p>
            </div>
        </div>

        <SkillBar />

        <div className={css.damage} id={damageAnchor}>
            <div className={css.damageBody}>
                <div className={css.col1}>
                    <a href={`#${damageAnchor}`}>
                        <h3>{i18n(`${prefix}.ad.header`)}</h3>
                    </a>
                    <Paras path={`${prefix}.ad.para`}/>
                </div>

                <div className={css.col2}>
                    <h3>{i18n(`${prefix}.h.header`)}</h3>
                    <Paras path={`${prefix}.h.para`} doReplace={true}/>
                    <img src={healingKey} />
                </div>
            </div>
        </div>
    </>;
}

